var u = 800, i = 16, o = Date.now;
function s(e) {
  var n = 0, t = 0;
  return function() {
    var a = o(), r = i - (a - t);
    if (t = a, r > 0) {
      if (++n >= u)
        return arguments[0];
    } else
      n = 0;
    return e.apply(void 0, arguments);
  };
}
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_shortOut.js
// module id = 1504
// module chunks = 41